export const SearchTargets = {
	// All LPs
	AllLPsSearch: 'all-lps-search',
};
